/**
 * Tool hero banners — PNG in /public/images/tools/ for stable OG/Twitter URLs.
 * WebP copies remain in src/assets/tool-banners/ for optional future use.
 */
const SITE_URL = 'https://pixelutility.com';

export const TOOL_BANNERS = {
  'resume-builder': {
    src: '/images/tools/resume-banner.webp',
    alt:
      'PixelUtility ATS resume builder on mobile, tablet, and desktop — responsive editor with professional templates, PDF and Word export',
    title: 'PixelUtility Resume Builder — responsive on all devices',
    caption:
      'Create your resume anywhere: start on mobile, refine on tablet, polish and download on desktop.',
    width: 1024,
    height: 539,
    ogImage: `${SITE_URL}/images/tools/resume-banner.webp`,
    keywords:
      'ATS resume builder, free resume maker, PDF resume export, Word resume download, responsive resume editor',
  },
  'qr-code-generator': {
    src: '/images/tools/qr-code-banner.webp',
    alt:
      'PixelUtility free QR code generator on laptop, tablet, and phone — customize URL, WiFi, vCard QR codes and download PNG or SVG',
    title: 'PixelUtility QR Code Generator — generate QR codes in seconds',
    caption:
      'Create, customize, and download QR codes for URL, WiFi, vCard, and more. No sign-up, privacy-first.',
    width: 1024,
    height: 682,
    ogImage: `${SITE_URL}/images/tools/qr-code-banner.webp`,
    keywords:
      'free QR code generator, static QR code, WiFi QR, custom QR design, PNG SVG QR download',
  },
  'clothing-shoe-size-converter': {
    src: '/images/tools/clothing-size-banner.webp',
    alt:
      'PixelUtility clothing and shoe size converter — EU, UK, US size conversion for men, women, and kids on mobile and desktop',
    title: 'PixelUtility Clothing & Shoe Size Converter — find your perfect size',
    caption:
      'Convert clothing and shoe sizes between EU, UK, US and more. Accurate, instant, worldwide.',
    width: 1024,
    height: 682,
    ogImage: `${SITE_URL}/images/tools/clothing-size-banner.webp`,
    keywords:
      'clothing size converter, shoe size EU to US, UK size chart, international size conversion, Nike Adidas sizing guide',
  },
};

export function getToolBanner(toolId) {
  return TOOL_BANNERS[toolId] ?? null;
}
